export default "__VITE_ASSET__5cba6164__"